export const environment = {
  production: true,
  apiHubUrl: "https://mv-api.azurewebsites.net/notificationsHub",
  appClientId: "fb7a1190-c223-42cb-9306-f8c0f0373588",
  appUrl: "https://client.mastervantagem.com", 
  apiUrl: "https://mv-api.azurewebsites.net/api/",
  authUrl: "https://siga-idserver.azurewebsites.net",
  authStorageKey: "mv.clientportal.user",

  contractTypeIds: {
    Business: 'C4A5E3A5-A64C-4962-ABDE-9C6C5368EDA5',
    Personal: 'E5F29B95-3983-48DD-ACBD-61D52930F489'
  },

  entityTypeIds: {
    Individual_entrepreneur: '52D611A2-378E-462C-B28F-C9BAAB05B99C',
    Company: '890024B8-F3C9-4081-96DB-C0BA3D8BA904',
    Private: 'B26E5445-0579-4AC4-BF03-A59D5DEE8639'
  },

  proposalStates: {
    To_sign: '31F34066-E2A9-4E41-BF5A-F222FCD72FDD',
    Incomplete: 'AE63E7DC-D3C5-4DFD-A984-3B3C4267E839',
    Lost: 'D707519C-B058-48D1-8F7B-5C45E099EBE7',
    To_be_validated: '9735DCBD-4E2A-4FEF-BBA5-61E9E2B75080',
    To_present: '70938719-9B9B-4808-A11F-8DC282738BD9',
    Canceled: '0146A05D-DBA5-4CBB-8F68-C8E244B1316E',
    Under_validation: '89F089DA-4936-40CA-8A5B-A1939BB93AF2',
    Hiring: 'C0440BF9-0660-483F-987D-578572E88627',
    Presented: '3AD04633-0F53-4458-A00E-91EC3102A806',
    Signed: '43B71CA0-0022-4F44-838F-BDA7281BD9FC',
    Accepted: '7532EA45-1E50-494B-8873-9A46961D4099',
    Won: 'DE18D04F-C805-456A-9F3C-FB0D37F95422'
  },
  
  opportunityContactOrigin: '1A7AD712-29F3-4AD4-BA8F-E5146ACB5715',
  blurPrices: true
};

